import { storage } from './storage';

let google = google || {};

class Map {
    constructor(resources) {
        this.resources = resources;
        this.bounds = null;
        this.maxDistanceInBounds = 5000;
        this.markers = [];
    }

    create(element, style) {
        const self = this;
        const map = new google.maps.Map(element, {
            center: { lat: 61.367832, lng: 16.626849 },
            zoom: 5,
            mapTypeControlOptions: {
                mapTypeIds: ['styled_map', 'satellite', 'hybrid'],
            },
        });

        self.bounds = new google.maps.LatLngBounds();
        map.mapTypes.set('styled_map', new google.maps.StyledMapType(style, { name: self.resources.map }));
        map.setMapTypeId('styled_map');

        return map;
    }

    markCurrentLocation(map, location) {
        const self = this;
        const marker = new google.maps.Marker({
            map: map,
            position: location,
            label: self.resources.yourLocation,
            icon: self.resources.icons.markerCurrentLocation,
        });

        self.mark(map, marker)
    }

    markLocation(map, location, clickCallback) {
        const self = this;
        const marker = new google.maps.Marker({
            map: map,
            position: location,
            icon: self.resources.icons.markerDefault,
        });

        self.mark(map, marker, clickCallback);
    }

    mark(map, marker, clickCallback) {
        const self = this;

        // Display name and address when marker is clicked
        if (typeof clickCallback === 'function') {
            marker.addListener('click', () => {
                clickCallback(marker);
            });
        }

        // Add to array so we can calculate bounds when all is done
        self.markers.push(marker);

        return marker;
    }

    fitBounds(map, addresses) {
        const self = this;

        // Add each address to bounds, if within max distance
        const within = addresses.filter((address) => {
            if (!address.distance || address.distance <= self.maxDistanceInBounds) {
                return address;
            }
        });

        // If no address are within bounds, show all addresses
        (within.length === 0 ? addresses : within).forEach((address) => {
            self.bounds.extend(address.location);
        });

        // Zoom out if too close
        google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
            if (map.getZoom() > 15) {
                map.setZoom(15);
            }
        });

        map.fitBounds(self.bounds);
    }

    addToBounds(loc) {
        const self = this;

        self.bounds.extend(loc);
    }
}

class Location {
    getCurrent() {
        return new Promise(function (resolve, reject) {
            const longitude = storage.get('longitude');
            const latitude = storage.get('latitude');

            if (latitude && latitude) {
                resolve(new google.maps.LatLng(JSON.parse(latitude), JSON.parse(longitude)));
            } else if (navigator.geolocation) {
                // Ask user/browser for current position
                navigator.geolocation.getCurrentPosition(function (position) {
                    storage.set('longitude', JSON.stringify(position.coords.longitude));
                    storage.set('latitude', JSON.stringify(position.coords.latitude));

                    resolve(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                }, function () {
                    reject();
                }, {
                    maximumAge: 60000, 
                    timeout: 30000, 
                    enableHighAccuracy: true,
                });
            } else {
                reject();
            }
        });
    }
}

class Geocode {
    code(loc, addresses, callback, error) {
        const self = this;

        let sequence = Promise.resolve();

        // Loop all addresses, geolocate and add distance
        addresses.forEach(function (address) {
            sequence = sequence.then(function () {
                return self.codeAddress(loc, address);
            }).then(function (address) {
                if (typeof callback === 'function') {
                    callback(address);
                }
            }).catch(function (err) {
                if (typeof error === 'function') {
                    error(err.message);
                }
            });
        });

        return sequence;
    }

    calculateDistance(loc, address) {
        const location = new google.maps.LatLng(address.location.lat, address.location.lng)

        return google.maps.geometry.spherical.computeDistanceBetween(loc, location);
    }

    codeAddress(loc, address) {
        const self = this;
        const geocoder = new google.maps.Geocoder();

        // Create promise for async geocoding call
        return new Promise(function (resolve, reject) {
            geocoder.geocode({ 'address': address.address + ' ' + address.city }, function (results, status) {
                if (status == 'OK') {
                    // All OK, add location and distance
                    address.place_id = results[0].place_id;
                    address.location = results[0].geometry.location;
                    address.distance = self.calculateDistance(loc, address);

                    resolve(address);
                } else {
                    reject(Error(status));
                }
            });
        });
    }
}

class Google {
    constructor() {
        this.currentPosition = null;
        this.maxDistanceInBounds = 50000;
        this.resources = {
            map: 'Karta',
            yourLocation: 'Din plats',
            icons: {
                markerDefault: '/images/map-marker.png',
                markerCurrentLocation: '/images/map-marker-position.png',
            },
        };

        this.location = new Location();
        this.geo = new Geocode();
    }

    init(googleApi, resources) {
        this.resources = resources || this.resources;
        this.map = new Map(this.resources);
        this.map.maxDistanceInBounds = this.maxDistanceInBounds;

        google = googleApi;
    }
}

export let geo = new Google


// WEBPACK FOOTER //
// ./scripts/booking/helpers/google.js